import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { ArrowLeftIcon, ArrowRightIcon } from 'app/agriculture/icons';
import { ComponentProps } from 'react';
import './StatRelationship.scss';

interface StatRelationshipProps {
    id?: string;
    arrowDirection?: 'left' | 'right';
    leftStatDisplay: ComponentProps<typeof StatDisplay>;
    rightStatDisplay: ComponentProps<typeof StatDisplay>;
}

export function StatRelationship({
    id,
    arrowDirection,
    rightStatDisplay,
    leftStatDisplay,
}: StatRelationshipProps) {
    return (
        <div className="StatRelationship" data-testid={id}>
            <StatDisplay
                className="StatRelationship__stat"
                id={`${id}-left-stat`}
                {...leftStatDisplay}
            />
            <div className="StatRelationship__arrow">
                {arrowDirection === 'left' && <ArrowLeftIcon />}
                {arrowDirection === 'right' && <ArrowRightIcon />}
            </div>
            <StatDisplay
                className="StatRelationship__stat"
                id={`${id}-right-stat`}
                {...rightStatDisplay}
            />
        </div>
    );
}
